import { IBookmarkSpecifiable, IBookmark } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { IntegerTranslator } from "../../values";
import { RelationTranslator } from "./RelationTranslator";

export class BookmarkTranslator {
  from(bean: IXElementContentsObjectBean): IBookmark {
    return this.relationalItems.from(
      bean,
      is => ({
        isEnable: true as boolean,
        value: is[0]["@value"],
        row: this.integer.from(is[0]["@row"]),
        column: this.integer.from(is[0]["@column"]),
      }),
      {
        isEnable: false,
        value: "",
        row: 1,
        column: 1,
      });
  }

  to(object: IBookmarkSpecifiable): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(object.bookmark.isEnable
      ? [{
        "@value": object.bookmark.value,
        "@value-type": "1",
        "@row": this.integer.to(object.bookmark.row),
        "@column": this.integer.to(object.bookmark.column),
      }]
      : []);
  }
  private readonly relationalItems = new RelationTranslator("jump-link");
  private readonly integer = new IntegerTranslator();
}
